// Single source of truth for status colors. Update here to restyle everywhere.
// Colors reference CSS variables from /src/design-tokens.css so that
// dark-mode + high-contrast automatically flip the palette (see
// `[data-theme="dark"]` and `[data-contrast="high"]` blocks there).
export const STATUS = {
  available:      { bg: "var(--status-available-bg)", outline: "var(--status-available-border)", text: "var(--status-available-text)", label: "Available" },
  reserved:       { bg: "var(--status-reserved-bg)", outline: "#0F2347",                        text: "var(--status-reserved-text)", label: "Reserved" },
  sold:           { bg: "var(--status-sold-bg)",     outline: "#7A5E0A",                        text: "var(--status-sold-text)",     label: "Sold (pending payment)" },
  funds_received: { bg: "var(--status-funds-bg)",    outline: "#7A1414",                        text: "var(--status-funds-text)",    label: "Funds Received" },
};

export const UNASSIGNED = { bg: "var(--status-unassigned-bg)", outline: "var(--border-strong)", text: "var(--status-unassigned-text)", label: "Unassigned" };

// Convenience legacy maps so existing references keep working.
export const STATUS_BG = {
  available: STATUS.available.bg,
  reserved: STATUS.reserved.bg,
  sold: STATUS.sold.bg,
  funds_received: STATUS.funds_received.bg,
};
